import { Box, Text } from '@chakra-ui/react'

import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'

import CustomTooltip from '../../CustomTooltip/CustomTooltip'

const Hint: React.FC<{
  hint?: string
  hintLink?: string
  width: number
  height: number
}> = ({ hint, hintLink, width, height }) => {
  const { brandColor } = useCurrentUser()
  if (hint && hintLink)
    return (
      <CustomTooltip label="For best results, upload a horizontal logo (320x96px) in transparent PNG or SVG format.">
        <Box
          className="body-small-emphasis"
          as="span"
          color={brandColor}
          textDecoration="underline"
        >
          {hintLink}
        </Box>
      </CustomTooltip>
    )

  hint ||= `${width} x ${height}px minimum`
  return (
    <Text color="graphite" className="body-extra-small" pr={8}>
      {hint}
    </Text>
  )
}

export default Hint
